import React from "react";
import { useTranslation } from "react-i18next";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppShell, Paper, Title, Center } from "@mantine/core";

export const Route = createFileRoute("/spring-health")({
  component: SpringRegistrationLayout,
});

function SpringRegistrationLayout() {
  const { t } = useTranslation();
  return (
    <AppShell>
      <AppShell.Main bg="#00382D" p="xl">
        <Paper p="xl">
          <Center mb="xl">
            <Title>{t("springHealth.layout.title")}</Title>
          </Center>
          <Outlet />
        </Paper>
      </AppShell.Main>
    </AppShell>
  );
}
